import { Card } from "@mui/material";
import styled from "styled-components";

export const StyledCard = styled(Card)`
  ${({ theme }) => `
    background-color: transparent !important;
    .MuiTypography-overline {
        padding-left: ${theme.uptimeSpace[4]}px;
    }
    .MuiCardContent-root {
        padding: ${theme.uptimeSpace[4]}px !important;
    }
    .MuiButton-root {
        width: 280px;
        height:42px;
        font-family: ${theme.uptimeFonts.primary};
    }
`}
`;
